module.exports = __webpack_public_path__ + "img/box.aff50af1.png";